export default __webpack_public_path__ + "static/media/1.67b7da72.jpg";